import { defineStore } from 'pinia';
// import { getUserInfo } from '@/request/api';  

// let userInfo = {}
// await getUserInfo().then(res => {
//   userInfo = res.data;
// })

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: '',
    menu: [],
  }),
  actions: {
    setUser(userInfo) {
      this.userInfo = userInfo || '';
    },
    setMenu(menu) {
      this.menu = menu || [];
    },
  },
});